/**
 * Purchase Limit Display
 * Reads limit data from OC Quantity Breaks & Limit app's DOM
 * and displays custom "お一人様N点まで" text next to quantity input
 */

(function () {
  'use strict';

  const SELECTORS = {
    appLimitTable: '.orichi-Limit',
    appMaxCell: '.orichi-Limit tbody td:last-child',
    quantityInput: 'quantity-input.quantity',
  };

  /**
   * Get the max purchase limit from the app's DOM
   * @returns {number|null} Max limit or null if not found/unlimited
   */
  function getMaxLimitFromApp() {
    const maxCell = document.querySelector(SELECTORS.appMaxCell);
    if (!maxCell) return null;

    const value = parseInt(maxCell.textContent.trim(), 10);
    // 0 means unlimited in the app
    if (isNaN(value) || value === 0) return null;

    return value;
  }

  /**
   * Create the limit text element
   * @param {number} maxLimit
   * @returns {HTMLElement}
   */
  function createLimitTextElement(maxLimit) {
    const span = document.createElement('span');
    span.className = 'product__limit-text';
    span.textContent = `お一人様${maxLimit}点まで`;
    return span;
  }

  /**
   * Wrap quantity input and limit text in a flex container
   * @param {HTMLElement} quantityInput
   * @param {HTMLElement} limitText
   */
  function wrapWithFlexContainer(quantityInput, limitText) {
    // Check if already wrapped
    if (quantityInput.parentElement.classList.contains('quantity-limit-wrapper')) {
      quantityInput.parentElement.appendChild(limitText);
      return;
    }

    const wrapper = document.createElement('div');
    wrapper.className = 'quantity-limit-wrapper';

    quantityInput.parentNode.insertBefore(wrapper, quantityInput);
    wrapper.appendChild(quantityInput);
    wrapper.appendChild(limitText);
  }

  /**
   * Initialize the purchase limit display
   */
  function init() {
    const maxLimit = getMaxLimitFromApp();

    // No limit set or unlimited
    if (!maxLimit) return;

    const quantityInput = document.querySelector(SELECTORS.quantityInput);
    if (!quantityInput) return;

    const limitText = createLimitTextElement(maxLimit);
    wrapWithFlexContainer(quantityInput, limitText);
  }

  /**
   * Wait for the app's DOM to be ready
   * The app loads data asynchronously, so we need to observe DOM changes
   */
  function waitForAppAndInit() {
    // Check if app's limit table already exists
    if (document.querySelector(SELECTORS.appLimitTable)) {
      init();
      return;
    }

    // Observe DOM for the app's table to be added
    const observer = new MutationObserver((mutations, obs) => {
      if (document.querySelector(SELECTORS.appLimitTable)) {
        obs.disconnect();
        init();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    // Timeout fallback - stop observing after 10 seconds
    setTimeout(() => {
      observer.disconnect();
    }, 10000);
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForAppAndInit);
  } else {
    waitForAppAndInit();
  }
})();
